import React from 'react';

export default class BaseComponent extends React.Component {

    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = this.props.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    }
}